// React
import React from 'react'
// Consts
import Colors from '../../../constants/Colors'

const EducationICon = ({ selected }) => {
  const fill = selected ? Colors.SECONDARY_COLOR : Colors.SECONDARY_FONT_COLOR
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M12.27 3.826l8.783 5.649c.11.11.197.25.197.398a.496.496 0 0 1-.238.407l-1.88 1.201v3.173a.496.496 0 0 1-.238.407l-1.805 1.153v.805c.49.193.837.687.837 1.24v1.496c0 .285-.21.495-.496.495h-1.7a.481.481 0 0 1-.496-.495v-1.496c0-.558.333-1.032.837-1.236v-.196l-3.784 2.418a.487.487 0 0 1-.3.122.31.31 0 0 1-.166-.042l-.091-.046-6.568-4.216c-.181-.06-.294-.253-.294-.433v-3.174l-1.824-1.174c-.18-.06-.294-.254-.294-.434 0-.163.094-.31.235-.404l8.741-5.615a.515.515 0 0 1 .545-.003zm4.298 14.119a.35.35 0 0 0-.334.272l-.007.067v1h.706v-1c0-.173-.175-.339-.365-.339zM5.86 12.121v2.274l6.127 3.935 4.084-2.635v-2.252l-3.784 2.418a.487.487 0 0 1-.3.122.274.274 0 0 1-.117-.02l-.117-.055-.024-.013L5.86 12.12zm10.728 3.829l-.017.011V17.4l-.19.047a.832.832 0 0 0-.623.612.852.852 0 0 1 .81-.614c.383 0 .73.267.834.62a.825.825 0 0 0-.615-.616l-.198-.041-.001-1.458zm1.527-3.833l-1.051.664v2.278l1.051-.665v-2.277zm-6.127-7.293L4.176 9.848l7.813 5.025 3.697-2.331-3.95-2.577a.49.49 0 0 1-.16-.687.486.486 0 0 1 .611-.196l.085.042 4.32 2.805 3.208-2.08-7.812-5.025zm8.732 5.024l-2.105 1.365v3.432l.014-.007.003.003v-3.434l2.106-1.346-.018-.013zm-7.707.353l3.55 2.316.001-.011-3.551-2.305z'
        />
      </g>
    </svg>
  )
}

export default EducationICon
